(() => {
    class Toggle {
        constructor() {
            this.exclusion = {};
        }
        get offers() {
            return Object.values(App.Endpoint.ToggleOffers.get);
        }

        addOption(id) {
            App.Interface.Api.get('carts.activatetoggleoffer', {id: id}, {async: false, cache: false});
            return this;
        }

        /**
         * Exclude Offers from displaying
         *
         * @param ids
         */
        exclude(ids = []) {
            ids.forEach(id => {
                this.exclusion[id] = id;
            });
            Shop.Cart.update();
        }

        /**
         * Get all offers sort by value
         */
        getToggleOffers() {
            return this.offers.sort(function(a, b) {
                return parseFloat(a.minValue) - parseFloat(b.minValue);
            });
        }

        /**
         * Get next possible offer
         */
        getNextToggleOffer() {
            let offers  = this.getToggleOffers();
            return offers.find(t => {
                if (t.toggleOfferReached === false && this.exclusion[t.id] === undefined) return true;
            });
        }

        isOneAvailable() {
            return new Promise(resolve => {
                App.Endpoint.ToggleOffers.get = () => resolve(this.getNextToggleOffer() !== undefined);
            });
        }

    }
    Shop.Cart.Toggle = new Toggle();
})();
